import { Component, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductService } from "../../shared/services/product.service";
import { Product, ordermodule } from "../../shared/classes/product";
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from 'src/app/shared/services/order.service';
import { ExternalService } from 'src/app/shared/services/external.service';
import { response } from 'express';
import { ToastrService } from 'ngx-toastr';
import { MyService } from 'src/app/shared/services/myservice';
@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  @ViewChild('loginModel', { static: true }) loginModel: ElementRef<any>

  public products: Product[] = [];
  public ecomproducts: ordermodule[] = [];
  public prodCart = []
  public prodweight = []
  public prodopt = []
  someCondition: any
  public Livecart: any = [];
  public addons
  public variants
  public Msg
  stringifiedData: any
  parsedJson: any = []
  public lenData: any = [];
  public TotalAMount = 0
  public SubTotal = 0
  public Ccount
  public CountCart = 0

  constructor(public productService: ProductService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal,
    public ordservice: OrderService, public externalService: ExternalService, private toastrService: ToastrService, private myService: MyService) {
    localStorage.setItem('mypg', '3');
    this.myService._pageId.next(3);
  }

  ngOnInit(): void {
    this.getCartItem()
    this.myService.HearderId.next(0);

  }

  public get getTotal(): Observable<number> {
    return this.productService.cartTotalAmount();
  }
  getTotalamt() {
    this.TotalAMount = 0
    this.totalQty = 0
    if (this.Livecart?.length > 0) {
      this.Livecart.forEach(data => {
        this.prodopt = data.options
        this.totalQty += data.Quantity_No
        // console.log(this.totalQty)
        data.SubTotal = ((data.weight.Price + ((data.addons.TPrice || 0) + (data.variants?.price || 0))) * data.Quantity_No)
        this.TotalAMount += data.SubTotal
        // console.log(this.TotalAMount)
      })
    }
  }
  totalQty: number = 0

  hidval: boolean = false
  getCartItem() {
    // console.log('utsdudddsgffhgfhg')
    this.totalQty = 0
    this.TotalAMount = 0
    this.productService.getLiveCart.subscribe(response => {
      // console.log(response)
      document.getElementById('preloadercrt').style.display = 'none'
      if (response['status'] == 500) {
        this.lenData = []
        this.Livecart = []
        this.hidval = true
      } else {
        this.lenData = response['cart'] || []
        this.Livecart = response["cart"] || []
        this.hidval = true
      }
      const count = this.Livecart?.length || 0
      // console.log(count)
      localStorage.setItem("myApp_CartCount", JSON.stringify(count));
      this.myService.cartsource.next(count);
      if (this.Livecart?.length > 0) {
        this.Livecart.forEach(data => {
          // console.log(data)
          data.QTY = data.Quantity_No
          this.totalQty += data.Quantity_No
          // console.log(this.totalQty)
          this.stringifiedData = JSON.stringify(data.options);
          this.parsedJson = JSON.parse(this.stringifiedData);
          const jsonObject: { [key: string]: any } = JSON.parse(this.parsedJson);
          // Convert jsonObject to an array
          const optionsArray = Object.keys(jsonObject).map((key) => jsonObject[key]);
          data.options = optionsArray;
          data.options.forEach(ele => {
            data.addons = ele.addons
            data.variants = ele.variants
            data.Msg = ele.msg
          })
          data.addons.forEach(adns => {
            data.addons.TPrice = 0;
            data.addons.TPrice += adns.price
          });
          data.SubTotal = ((data.weight.Price + (((data.addons.TPrice || 0)) + ((data.variants?.price || 0)))) * data.Quantity_No)
          this.TotalAMount += data.SubTotal
        })
        // console.log(this.Livecart)
        this.fdata = JSON.parse(localStorage.getItem("fav"));
        // console.log(this.fdata)
        if (this.fdata != null) {
          setInterval(() => {
            this.fdata.forEach(y => {
              this.Livecart.forEach(liv => {
                if (liv.ProductId === y.pid) {
                  liv.fav = true;
                }
              })
              // if (this.Livecart.productId === y.pid) {
              //   this.Livecart.fav = true;
              // }
            });

          }, 300);
        }

        // console.log(this.Livecart)

      }
      document.getElementById('preloadercrt').style.display = 'none'

      // console.log(this.Livecart)
    });
  }


  editData: any = {
    id: 0,
    Qty: 0
  }

  increment(product, qty = 1) {
    // console.log(product)
    if (product.Quantity_No < 10) {
      this.productService.updateCartQuantity(product, qty);
      product.Quantity_No++;
    }
    this.getTotalamt()
  }


  // Decrement
  decrement(product, qty = -1) {
    // console.log(product)
    if (product.Quantity_No > 1) product.Quantity_No--;
    this.productService.updateCartQuantity(product, qty);
    this.getTotalamt()
  }

  public removeItem(id) {
    // console.log(id)
    document.getElementById('preloadercrt').style.display = 'block'
    this.externalService.DeleteCart(id)
    this.externalService._getCartDel.subscribe(response => {
      this.toastrService.warning('Removed from Cart!', '')
      this.getCartItem()
    })
  }

  public modalOpen: boolean = false;
  openModal() {
    this.modalOpen = true;
    this.modalService.open(this.loginModel, {
      size: 'lg',
      ariaLabelledBy: 'Cart-Modal',
      centered: true,
      windowClass: 'theme-modal cart-modal CartModal'
    })

  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }

  checkoutdata: any
  checkoutss() {
    this.checkoutdata = this.ecomproducts
    this.router.navigateByUrl('/shop/checkout')
  }
  async checkout(product: any) {
    // product.quantity = this.counter || 1;
    const status = await this.productService.addToCart(product);
    if (status)
      this.router.navigate(['/shop/checkout']);
  }
  isAuthenticated: boolean = false;

  isLoggedIn(): boolean {
    return localStorage.getItem('denglu') == '1';
  }

  CheckOutss(): void {
    if (this.isLoggedIn()) {
      this.router.navigate(['/shop/checkout']);
    } else {
      alert('Please login to proceed to checkout.');
      this.router.navigate(['/pages/login'])
    }
  }
  Qtydata: any = []
  CheckOut(): void {
    document.getElementById('preloadercrt').style.display = 'block'
    if (localStorage.getItem('denglu') === '1') {
      // console.log('11111111111')
      this.Livecart.forEach(element => {
        if (element.QTY != element.Quantity_No) {
          const data = {
            id: element.cartid,
            Qty: element.Quantity_No
          }
          this.Qtydata.push(data)
        }
        // else {
        //   this.Qtydata = []
        // }
        // console.log('AAAAAAAAAA')

      });
      // console.log(this.Qtydata)
      if (this.Qtydata.length > 0) {
        this.externalService.UpdateQty(this.Qtydata)
        this.externalService._getUpdateQty.subscribe(response => {
          // console.log(response)
          document.getElementById('preloadercrt').style.display = 'none'
          this.router.navigate(['/shop/checkout']);

        })
        // console.log('bbbbbbbbbb')

      } else {
        document.getElementById('preloadercrt').style.display = 'none'
        this.router.navigate(['/shop/checkout']);
        // console.log('ccccccccccccc')

      }
    }
    else {
      this.modalService.open(this.loginModel, { centered: true, size: 'lg' });
      document.getElementById('preloadercrt').style.display = 'none'
    }
  }


  logincheck() {
    this.modalService.dismissAll();
    this.router.navigate(['/pages/login'])
  }
  TypeId: number = 0
  edit(id, cartId, name, typeID) {
    if (typeID != 4) {
      this.router.navigate(['/shop/product/left/sidebar/', id, name, cartId]);

    }
  }
  public ImageSrc: string



  fdata: any
  addToWishlist(item: any) {
    item.fav = !item.fav;
    // console.log(item);

    const itemdata = {

      avg_star: 0,
      cid: item.products.CategoryId,
      cname: "",
      fav: true,
      img: item.products.ImgUrl,
      pid: item.ProductId,
      pname: item.products.Name,
      preDef: [],
      pri: item.weight.Price,
      qty_price: [],
      starscount: 0,
      starsum: 0,
    }

    let favData = localStorage.getItem("fav") ? JSON.parse(localStorage.getItem("fav")) : [];

    let isPresent = favData.some((el: any) => el.pid === itemdata.pid);

    if (isPresent) {
      favData = favData.filter((el: any) => el.pid !== itemdata.pid);
      localStorage.setItem("fav", JSON.stringify(favData));
      this.toastrService.warning('Removed Favourite', itemdata.pname);
      this.Livecart.fav = false;  // Fixing the fav property update
    } else {
      favData.push(itemdata);
      localStorage.setItem("fav", JSON.stringify(favData));
      this.toastrService.success('Saved Favourite', itemdata.pname);
      this.Livecart.fav = true; // Mark product as favorite
    }

    this.fdata = favData;
  }

}


